export enum EnumTypeReports {
    operators = 'Operador',
    suppliers = 'Fornecedor',
    staff = 'Staff'
}
